import React, { useState, useRef,useEffect,useCallback, useLayoutEffect  } from "react";
import { Link, useLocation } from "react-router-dom";
import { useHeaderFilters } from "../../context/HeaderFilterContext";
import CommonSelect from "../../core/common/commonSelect";
import type { Option } from "../../core/common/commonSelect";
import api from "../../api";
import { useParams, useNavigate } from "react-router-dom";
import { encryptQuery, decryptQuery } from "../../utils/encryption";
import Table from "../../core/common/dataTable/index";
import useDynamicPageSize from "../../useDynamicPageSize";
import Footer from "../../Footer";
import "bootstrap/dist/js/bootstrap.bundle.min";
import moment from "moment";
import { ColumnsType } from "antd/es/table";
import LeaveModal from "./LeaveModal";
import { useSelector } from "react-redux";
import { useFilterData } from "../../context/FilterContext";
import { toast,ToastContainer } from 'react-toastify';


const Leave = () => {
  const { setFilters } = useHeaderFilters();
  const navigate = useNavigate();
  const location = useLocation();
  const { encryptedQuery } = useParams<{
    activeTab: string;
    encryptedQuery?: string;
  }>();
  const { activeTab } = useParams();
  const isInitialFetch = useRef(true);
  const { filtersData } = useFilterData();

  const dataLayout = useSelector((state: any) => state.themeSetting.dataLayout);
  const expandedWidth = 40;
  const collapsedWidth = 72;
  const sidebarWidth =
    dataLayout === "mini_layout" ? collapsedWidth : expandedWidth;

  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageLeaveBalance, setCurrentPageLeaveBalance] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [totalItemsLeaveBalance, setTotalItemsLeaveBalance] = useState(0);
  const pageSize = useDynamicPageSize();
  const [tableHeight, setTableHeight] = useState<number>(0);

 useLayoutEffect(() => {
    //  if (pageSize === 0) return;
    const calculateHeight = () => {
      const baseOffset = 194;
      const extraOffset = window.innerWidth <= 991 ? -43 : -81;
      const fixedOffset = baseOffset + extraOffset;

      const newHeight = window.innerHeight - fixedOffset;

      console.log("Calculated table height:", newHeight);
      console.log("fixedOffset:", fixedOffset);
      console.log("window.innerHeight:", window.innerHeight);
      console.log("totalItems :", totalItems);
      console.log("pagesize :", pageSize);
      setTableHeight(newHeight);
    };

    calculateHeight(); // initial + on totalItems change
    window.addEventListener("resize", calculateHeight);

    return () => window.removeEventListener("resize", calculateHeight);
  }, [totalItems, pageSize]);

  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  const [isReportingHead, setIsReportingHead] = useState(false);
  const initialRole = storedUser?.role_name ?? null;
  const [userRole, setUserRole] = useState<number | null>(initialRole);
  const [loggedInUserId, setLoggedInUserId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [employeesFilter, setEmployeesFilter] = useState<Employee[]>([]);
  const [employeesFilterLeaveBalance, setEmployeesFilterLeaveBalance] =
    useState<Employee[]>([]);
  const [statusFilter, setStatusFilter] = useState<
    { value: string; label: string }[]
  >([]);
  const [employeesForm, setEmployeesForm] = useState<Employee[]>([]);
  const [selectedStatus, setSelectedStatus] = useState<string | null>("0");
  const [selectedUserId, setSelectedUserId] = useState<number | null>(0);
  const initialId = storedUser?.id ?? null;
  const [selectedUserIdLeaveBalance, setSelectedUserIdLeaveBalance] = useState<
    number | null
  >(initialId);
  const [tab, setTab] = useState(activeTab || "leave-request");
  const [leaveRequests, setLeaveRequests] = useState<LeaveDetailsItem[]>([]);
  const [leaveBalanceList, setLeaveBalanceList] = useState<LeaveBalanceEntry[]>(
    []
  );
  const [lopCount, setLopCount] = useState<number>(0);
  const [leaveBalance, setLeaveBalance] = useState<number>(0);
  const [totalDuration, setTotalDuration] = useState<number>(0);
  const modalRefRequest = useRef<HTMLDivElement | null>(null);
  const modalRefRequestLeaveBalance = useRef<HTMLDivElement>(null);
  const modalInstanceRef = useRef<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenLeaveBalance, setIsModalOpenLeaveBalance] = useState(false);
  const [isSaving, setIsSaving] = useState<boolean>(false);

  type ValidationErrors = {
    selectedType?: string;
    noOfLeave?: string;
    notes?: string;
  };

  const [validationErrors, setValidationErrors] = useState<ValidationErrors>(
    {}
  );
  const [leaveErrorMessage, setLeaveErrorMessage] = useState<string>("");
  const [noOfLeave, setNoOfLeave] = useState<number | string>("");
  const [selectedType, setSelectedType] = useState<string>(""); // Default to Credit
  const [notes, setNotes] = useState<string>("");

  const isDateInPast = (date: string) => {
    return moment(date).isBefore(moment(), "day");
  };

  const formatDate = (date: string) =>
    date ? moment(date, "YYYY-MM-DD").format("DD-MMM-YYYY") : "";
  const formatLeaveAppliedDate = (date: string) =>
    date ? moment(date).format("DD-MMM-YYYY hh:mm A") : "";

  const [leaveDetails, setLeaveDetails] = useState<LeaveDetails>({
    showModal1: false,
    isEditMode: false,
    leaveType: undefined,
    leaveDuration: "",
    singleDate: "",
    startDate: "",
    endDate: "",
    halfShortDate: "",
    halfDayType: "",
    reason: "",
    status: "",
    disableAllFields: false,
    disableAllExceptStatus: false,
    leaveAppliedDate: "",
    selectedEmployeeId: parseInt(loggedInUserId || "0"),
    users: employeesForm,
  });

  interface LeaveDetails {
    showModal1: boolean;
    isEditMode: boolean;
    editId?: number;
    leaveType: number | undefined;
    leaveDuration: string;
    singleDate: string;
    startDate: string;
    endDate: string;
    halfShortDate: string;
    halfDayType: string;
    reason: string;
    status: string;
    disableAllFields: boolean;
    disableAllExceptStatus: boolean;
    userId?: number;
    leaveAppliedDate: string;
    users: Employee[];
    selectedEmployeeId: number | undefined;
    validationErrors?: any;
    currentPage?: number;
    pageSize?: number;
    optional_holiday?: 0 | 1;
    optional_holiday_taken_flag?: 0 | 1; 
  }

  useEffect(() => {
    if (isModalOpen && modalRefRequest.current) {
      const modal = new window.bootstrap.Modal(modalRefRequest.current);
      modal.show();

      modalRefRequest.current.addEventListener("hidden.bs.modal", () => {
        setIsModalOpen(false);
      });
    }
  }, [isModalOpen]);

  useEffect(() => {
    if (modalRefRequestLeaveBalance.current) {
      modalInstanceRef.current = new window.bootstrap.Modal(
        modalRefRequestLeaveBalance.current
      );

      modalRefRequestLeaveBalance.current.addEventListener(
        "hidden.bs.modal",
        () => {
          setIsModalOpenLeaveBalance(false);
        }
      );
    }
  }, []);

  interface LeaveRequestFilterParams {
    selectedUserId: number | null;
    selectedStatus: string | null;
    currentPage?: number;
  }

  interface LeaveBalanceFilterParams {
    selectedUserIdLeaveBalance: number | null;
    currentPageLeaveBalance?: number;
  }

  const defaultLeaveRequestFilters: LeaveRequestFilterParams = {
    selectedUserId: 0,
    selectedStatus: "0",
    currentPage: 1,
  };

  const defaultLeaveBalanceFilters: LeaveBalanceFilterParams = {
    selectedUserIdLeaveBalance: initialId,
    currentPageLeaveBalance: 1,
  };

  const areLeaveRequestFiltersDefault = (filters: LeaveRequestFilterParams) => {
    return (
      (filters.selectedUserId ?? 0) ===
        defaultLeaveRequestFilters.selectedUserId &&
      (filters.selectedStatus ?? "0") ===
        defaultLeaveRequestFilters.selectedStatus &&
      (filters.currentPage ?? 1) === defaultLeaveRequestFilters.currentPage
    );
  };

  const areLeaveBalanceFiltersDefault = (filters: LeaveBalanceFilterParams) => {
    return (
      (filters.selectedUserIdLeaveBalance ?? initialId) ===
        defaultLeaveBalanceFilters.selectedUserIdLeaveBalance &&
      (filters.currentPageLeaveBalance ?? 1) ===
        defaultLeaveBalanceFilters.currentPageLeaveBalance
    );
  };

  useEffect(() => {
  const savedKey = tab === "leave-request" ? "LeaveRequestFilters" : "LeaveBalanceFilters";

  // Ensure route matches the current tab path
  const expectedPath = `/leave/${tab}`;
  if (!location.pathname.startsWith(expectedPath)) {
    return; // Ignore side effects if not on correct route
  }

  if (encryptedQuery && employeesFilter.length) {
    try {
      const decoded = decodeURIComponent(encryptedQuery);
      const result = decryptQuery(decoded);

      if (result && typeof result === "object") {
        if (tab === "leave-request") {
          const data = result as LeaveRequestFilterParams;

          const userExists = employeesFilter.some(
            (emp) => emp.id === data.selectedUserId
          );

          setSelectedUserId(userExists ? data.selectedUserId : 0);
          setSelectedStatus(data.selectedStatus || "0");
          setCurrentPage(data.currentPage ?? 1);
        } else if (tab === "leave-balance") {
          const data = result as LeaveBalanceFilterParams;

          setSelectedUserIdLeaveBalance(
            data.selectedUserIdLeaveBalance || 0
          );
          setCurrentPageLeaveBalance(data.currentPageLeaveBalance ?? 1);
        }

        return;
      }
    } catch (e) {
      console.warn("Failed to decrypt query:", e);
    }
  }

  // Only try to restore if path is correct AND query is missing
  if (!encryptedQuery && employeesFilter.length) {
    const saved = localStorage.getItem(savedKey);
    if (saved) {
      const encoded = encodeURIComponent(saved);
      navigate(`${expectedPath}/${encoded}`, { replace: true });
      return;
    }
  }

  // Only fallback if on correct path and nothing else matches
  if (employeesFilter.length) {
    if (tab === "leave-request") {
      setSelectedUserId(0);
      setSelectedStatus("0");
      setCurrentPage(1);
    } else if (tab === "leave-balance") {
      setSelectedUserIdLeaveBalance(initialId);
      setCurrentPageLeaveBalance(1);
    }
  }
}, [encryptedQuery, tab, employeesFilter, navigate, initialId, location.pathname]);


 const updateFilterUrl = (
  filters: LeaveRequestFilterParams | LeaveBalanceFilterParams,
  baseRoute?: string
) => {
  const isLeaveRequest = tab === "leave-request";
  const storageKey = isLeaveRequest ? "LeaveRequestFilters" : "LeaveBalanceFilters";

  const isDefault = isLeaveRequest
    ? areLeaveRequestFiltersDefault(filters as LeaveRequestFilterParams)
    : areLeaveBalanceFiltersDefault(filters as LeaveBalanceFilterParams);

  const route =
    baseRoute || (isLeaveRequest ? "/leave/leave-request" : "/leave/leave-balance");

  if (isDefault) {
    navigate(route, { replace: false });
    localStorage.removeItem(storageKey);
  } else {
    const encrypted = encryptQuery(filters);
    localStorage.setItem(storageKey, encrypted);
    const encoded = encodeURIComponent(encrypted);
    navigate(`${route}/${encoded}`, { replace: false });
  }
};

  const handleImageClick = (
    employeeId: string | number,
    employeeName: string
  ) => {
    const previousUrl = location.pathname + location.search;
    navigate(`/profile/${employeeId}`, {
      state: {
        from: "leave",
        employeeName,
        leaveUrl: previousUrl,
      },
    });
  };

  const columns: ColumnsType<LeaveDetailsItem> = [
    {
      title: "Name",
      dataIndex: "user_name",
      width: "35%",
      render: (text: string, record: any) => {
        const maxNameLength = 20;
        const maxDesignationLength = 25;

        const truncateText = (text: string, maxLength: number) =>
          text && text.length > maxLength
            ? text.substring(0, maxLength) + "..."
            : text;

        return (
          <div
            className="d-flex align-items-center file-name-icon"
            onClick={
              userRole === 1
                ? () => handleImageClick(record.user_id, record.user_name)
                : undefined
            }
            style={{ cursor: userRole === 1 ? "pointer" : "default" }}
          >
            <Link to="#" className="avatar avatar-md border avatar-rounded">
              <img
                src={record.image_url || "assets/img/users/default.jpg"}
                className="img-fluid"
                alt="img"
              />
            </Link>
            <div className="ms-2">
              <h6 className="fw-medium" title={record.user_name}>
                <Link to="#">
                  {truncateText(record.user_name, maxNameLength)}
                </Link>
              </h6>
              <span className="fs-12 fw-normal" title={record.designation}>
                {truncateText(record.designation_title, maxDesignationLength)}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      title: "Duration",
      dataIndex: "duration",
      key: "duration",
      width: "20%",
      render: (_: any, record: LeaveDetailsItem) => {
        const { leave_type, duration, half } = record;

        const getDurationLabel = () => {
          if (leave_type === 1) {
            if (duration === "0.5") {
              return half === 1
                ? "First Half Leave"
                : half === 2
                ? "Second Half Leave"
                : duration;
            } else if (duration === "0.25") {
              return half === 1
                ? "First Half - Short Leave"
                : half === 2
                ? "Second Half - Short Leave"
                : duration;
            } else {
              return `${duration} Day(s)`;
            }
          } else if (leave_type === 2) {
            return half === 1
              ? "WFH - First Half"
              : half === 2
              ? "WFH - Second Half"
              : `WFH - ${duration} Day(s)`;
          }
          return null;
        };

        return getDurationLabel();
      },
    },
    {
      title: "Date",
      key: "start_date",
      width: "20%",
      render: (_: any, record: LeaveDetailsItem) => {
        const startDate = new Date(record.start_date);
        const endDate = new Date(record.end_date || record.start_date);

        const format = (d: Date) => {
          const formatted = d
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
            .replace(/ /g, "-");

          // Capitalize month (e.g., "30-Apr-2025" => "30-APR-2025")
          const parts = formatted.split("-");
          parts[1] = parts[1].toUpperCase();
          return parts.join("-");
        };

        return startDate.getTime() === endDate.getTime()
          ? format(startDate)
          : `${format(startDate)} - ${format(endDate)}`;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      width: "15%",
      key: "status",
      align: "center",
      render: (status: number, record: any) => {
        const statusTextMap: Record<number, string> = {
          1: "Pending",
          2: "Approved",
          3: "Rejected",
          4: "Sanctioned",
          5: "Revoked",
        };

        const statusText = statusTextMap[status] || "Unknown";
        const lopValue = record?.lop ?? 0;

        const styleMap: Record<string, React.CSSProperties> = {
          Sanctioned: {
            background: "#9FF4C4",
            color: "#34714E",
          },
          Approved: {
            background: "#AFC2FF",
            color: "#3F4D92",
          },
          Pending: {
            background: "#CD8B015E",
            color: "#A87C20",
          },
          Rejected: {
            background: "#FF060661",
            color: "#C24242",
          },
          Revoked: {
            background: "#FF060661",
            color: "#C24242",
          },
        };

        // Combine status text with LOP if applicable
        const displayText =
          statusText && lopValue > 0
            ? `${statusText} - LOP(${lopValue})`
            : statusText;

        return (
          <span
            style={{
              ...styleMap[statusText],
              fontSize: "14px",
              padding: "2px 6px",
              borderRadius: "4px",
              width: "160px",
              textAlign: "center",
              height: "30px",
              lineHeight: "30px",
              display: "inline-block",
            }}
          >
            {displayText}
          </span>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      width: "10%",
      align: "center",
      render: (_: any, record: any) => (
        <button
          type="button"
          className="btn btn-icon btn-sm"
          title="Edit"
          onClick={() => handleEdit(record)}
        >
          <i className="ti ti-edit" />
        </button>
      ),
    },
  ];

  const leaveBalanceColumns: ColumnsType<LeaveBalanceEntry> = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      width: "10%",
      render: (date: string) => {
        const formatted = new Date(date)
          .toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
          .replace(/ /g, "-");

        const parts = formatted.split("-");
        parts[1] = parts[1].toUpperCase();
        return parts.join("-");
      },
    },
    {
      title: "Notes",
      dataIndex: "notes",
      key: "notes",
      width: "45%",
      render: (notes: string) => (
        <span
          title={notes}
          className="notes"
        >
          {notes}
        </span>
      ),
    },
    {
      title: "Leaves (+/-)",
      dataIndex: "no_of_leaves",
      key: "no_of_leaves",
      width: "20%",
      render: (_: number, record: LeaveBalanceEntry) => {
        const isAddition = record.type === 1;

        return (
          <span
            style={{
              color: isAddition ? "green" : "red",
              display: "flex",
              alignItems: "center",
            }}
          >
            <i
              className={`fa ${isAddition ? "fa-plus" : "fa-minus"}`}
              style={{ marginRight: "5px" }}
            />
            {Math.abs(record.no_of_leaves)}
          </span>
        );
      },
    },
    {
      title: "Balance",
      dataIndex: "total_leaves",
      key: "total_leaves",
      width: "20%",
      render: (total_leaves: number) => <span>{total_leaves}</span>,
    },
  ];

  useEffect(() => {
    if (activeTab) {
      setTab(activeTab);
    }
  }, [activeTab]);

  interface Employee {
    id: number;
    name: string;
    [key: string]: any;
  }

  interface LeaveFilterDataResponse {
    leave_status: {
      [key: number]: string;
    };
    filter_employees: Employee[];
    names: Employee[];
    reporting_head_flag: boolean;
  }

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
    const loggedInUserId = String(storedUser?.id);
    setLoggedInUserId(loggedInUserId);
  }, []); // run once on mount

  useEffect(() => {
    if (filtersData && Object.keys(filtersData).length > 0) {
      const allEmployeesOption = {
          id: 0,
          name: "All Employees",
          image_url: "",
        };
        const updatedEmployeesFilter = [
          allEmployeesOption,
          ...filtersData?.filter_employees,
        ];

        const allStatusOption = {
          value: "0",
          label: "All Status",
        };

        const statusOptions = [
          allStatusOption,
          ...Object.entries(filtersData?.leave_status).map(([key, value]) => ({
            value: key,
            label: String(value),
          })),
        ];

        setEmployeesFilter(updatedEmployeesFilter);
        setEmployeesFilterLeaveBalance(filtersData?.filter_employees)
        setStatusFilter(statusOptions);
        setEmployeesForm(filtersData?.names);
        setSelectedUserId(0);
        setIsReportingHead(filtersData?.reporting_head_flag); 
    }
  }, [filtersData]);

  interface LeaveDetailsItem {
    id: number;
    user_id: number;
    designation_title: string;
    user_name: string;
    image_url: string;
    reporting_head_id: number;
    duration: string;
    start_date: string;
    end_date: string | null;
    status: number;
    half: number;
    leave_type: number;
    lop: number;
     optional_holiday?: 0 | 1;
  }

  interface LeaveBalanceEntry {
    id: number;
    user_id: number;
    leave_id: number | null;
    date: string;
    no_of_leaves: number;
    type: number;
    notes: string;
    total_leaves: number;
    flag: number;
    created_at: string; // ISO datetime string
    updated_at: string; // ISO datetime string
  }

  interface LeaveApiResponse {
    leavedetails: {
      current_page: number;
      data: LeaveDetailsItem[];
      total: number;
    };
    lopCount: number;
    leavebalance: number;
    totalduration: number;
  }

  interface LeaveBalanceApiResponse {
    leave: {
      current_page: number;
      data: LeaveBalanceEntry[];
      total: number;
    };
    lopCount: number;
    leavebalance: number;
    totalduration: number;
  }

  const fetchLeaveRequests = useCallback(async () => {
    const userString = localStorage.getItem("user");
    const user = userString ? JSON.parse(userString) : {};
    const { id } = user;

    try {
      setLoading(true);
      const apiUrl =
        userRole === 1 ? "/filter-leaves" : "/filter-leaves-employee";

      const payload = {
        id,
        userRole,
        employee: selectedUserId,
        status: selectedStatus,
        currentPage,
        pageSize,
      };

      const response: LeaveApiResponse = await api(apiUrl, {
        method: "POST",
        body: payload,
      });

      setLeaveRequests(response.leavedetails.data);
      setLopCount(response.lopCount);
      setLeaveBalance(response.leavebalance);
      setTotalDuration(response.totalduration);
      setTotalItems(response.leavedetails.total ?? 0);
    } catch (error) {
      console.error("Failed to fetch leave requests:", error);
    } finally {
      setLoading(false);
    }
  }, [userRole, selectedUserId, selectedStatus, currentPage, pageSize]);

  const fetchLeaveBalance = useCallback(async () => {
    setLoading(true);
    const userString = localStorage.getItem("user");
    const user = userString ? JSON.parse(userString) : {};
    const id = selectedUserIdLeaveBalance || user.id;

    try {
      const apiUrl =
        userRole === 1 ? "/show-leave-balance" : "/show-employee-leave-balance";

      const payload = {
        id,
        currentPage2: currentPageLeaveBalance,
        pageSize,
      };

      const response: LeaveBalanceApiResponse = await api(apiUrl, {
        method: "POST",
        body: payload,
      });

      setLeaveBalanceList(response.leave.data);
      setLopCount(response.lopCount);
      setLeaveBalance(response.leavebalance);
      setTotalDuration(response.totalduration);
      setTotalItemsLeaveBalance(response.leave.total ?? 0);
    } catch (error) {
      console.error("Failed to fetch leave requests:", error);
    } finally {
      setLoading(false);
    }
  }, [selectedUserIdLeaveBalance, userRole, currentPageLeaveBalance, pageSize]);

  useEffect(() => {  
    if (isInitialFetch.current) {
      isInitialFetch.current = false;
      return;
    }
    if (tab === "leave-request" && userRole !== null && selectedUserId !== null) {
      fetchLeaveRequests();
    }
    if (tab === "leave-balance") {
      fetchLeaveBalance();
    }
  }, [
    tab,
    userRole,
    selectedUserId,
    selectedStatus,
    selectedUserIdLeaveBalance,
    currentPage,
    currentPageLeaveBalance,
    pageSize,
    fetchLeaveRequests,
    fetchLeaveBalance,
  ]);

  const handleReset = () => {
    if (tab === "leave-request") {
      setSelectedUserId(0);
      setSelectedStatus("0");
      setCurrentPage(1);
      localStorage.removeItem("LeaveRequestFilters");
      navigate(`/leave/leave-request`, { replace: false });
    } else if (tab === "leave-balance") {
      setSelectedUserIdLeaveBalance(initialId);
      setCurrentPageLeaveBalance(1);
      localStorage.removeItem("LeaveBalanceFilters");
      navigate(`/leave/leave-balance`, { replace: false });
    }
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    handleResize(); // run once on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleUserChange = (userId: number | null) => {
    setSelectedUserId(userId);

    updateFilterUrl({
      selectedUserId: userId,
      selectedStatus,
    });
  };

  const handleUserChangeLeaveBalance = (userId: number | null) => {
    setSelectedUserIdLeaveBalance(userId);

    updateFilterUrl({
      selectedUserIdLeaveBalance: userId,
    });
  };

  const handleStatusChange = (status: string | null) => {
    setSelectedStatus(status || "0");
    console.log("handleStatusChange selectedUserId:", selectedUserId);

    updateFilterUrl({
      selectedUserId,
      selectedStatus: status,
    });
  };

  interface LeaveEditResponse {
    optional_holiday_taken_flag: number;
    duration: string;
    half: number;
    from_date: string;
    to_date?: string;
    reason?: string;
    leave_type?: number;
    status: number;
    user_id: number;
    created_at: string;
    optional_holiday?: number; 
    optional_holiday_taken?: number;
  }

  const isDateToday = (dateStr: string) => {
    const inputDate = new Date(dateStr);
    const today = new Date();
    return (
      inputDate.getFullYear() === today.getFullYear() &&
      inputDate.getMonth() === today.getMonth() &&
      inputDate.getDate() === today.getDate()
    );
  };

  const handleLeaveSaved = () => {
  setTotalItems((prevCount) => {
    const newCount = prevCount + 1;
    setCurrentPage(1);
    updateFilterUrl({
      selectedUserId,
      selectedStatus,
      currentPage: 1,
    });
    fetchLeaveRequests();
    return newCount;
  });
};

  const handleEdit = async (leaveRequest: any) => {
    const { id } = leaveRequest;
  

    try {
      const response = await api<LeaveEditResponse>(
        `/edit-leave-request/${id}`,
        {
          method: "GET",
        }
      );

      const data = response;

      let leaveDuration = "";
      if (data.duration === "1") leaveDuration = "single";
      else if (data.duration === "0.5") leaveDuration = "half";
      else if (data.duration === "0.25") leaveDuration = "short";
      else if (parseInt(data.duration) > 1) leaveDuration = "multi";

      let half = "";
      if (data.half === 1) half = "first-half";
      else if (data.half === 2) half = "second-half";

      const isSingleDatePast = isDateInPast(data.from_date);
      const isEndDatePast = data.to_date ? isDateInPast(data.to_date) : false;
      const isToday = isDateToday(data.from_date);
      const isToDateToday = data.to_date ? isDateToday(data.to_date) : false;

      const disableAllExceptStatus = userRole === 2 && data.status === 2;

      const localDisableAllFields =
        disableAllExceptStatus
          ? true
          : [3, 5].includes(data.status) ||
            (data.status === 4 &&
              isSingleDatePast &&
              (!data.to_date || isEndDatePast) &&
              (userRole === 1 || userRole === undefined)) ||
            ((data.status === 4 || data.status === 2) &&
              userRole === 2 &&
              (!data.to_date || isEndDatePast));


      console.log("selectedUserId leave:", data.user_id);

      setLeaveDetails({
        showModal1: true,
        isEditMode: true,
        editId: id,
        leaveType: data.leave_type || undefined,
        leaveDuration,
        singleDate: formatDate(data.from_date),
        startDate: formatDate(data.from_date),
        endDate: formatDate(data.to_date ?? ""),
        halfShortDate: formatDate(data.from_date),
        halfDayType: half,
        reason: data.reason || "",
        status: String(data.status) || "",
        disableAllFields: localDisableAllFields,
        disableAllExceptStatus,
        userId: data.user_id || 0,
        leaveAppliedDate: formatLeaveAppliedDate(data.created_at),
        users: employeesForm,
        selectedEmployeeId: selectedUserId ?? 0,
        validationErrors,
        currentPage,
        pageSize,
        optional_holiday: Number(data.optional_holiday ?? 0) as 0|1,
        optional_holiday_taken_flag: Number(data.optional_holiday_taken_flag ?? 0) as 0 | 1,
      });
        setIsModalOpen(true);
    } catch (error) {
      console.error("Error fetching leave request:", error);
    }
  };

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    console.log("closemodal called:", isModalOpen);
    setLeaveDetails({} as LeaveDetails);
  }, []);

  const closeModalLeaveBalance = () => {
    if (modalInstanceRef.current) {
      modalInstanceRef.current.hide();
    }
    setNoOfLeave("");
    setNotes("");
    setSelectedType("");
  };

  const handleLeaveError = useCallback((errorMessage: string) => {
    console.log("Received error in Leave.tsx:", errorMessage);
    setLeaveErrorMessage(errorMessage);
    setTimeout(() => {
      setLeaveErrorMessage("");
    }, 1000);
  }, []);

  const openAddLeaveRequestModal = async () => {
    setIsModalOpen(true);
    console.log("isModalOpen:", isModalOpen);

    const id = JSON.parse(localStorage.getItem("user") || "{}")?.id;

    setLeaveDetails((prev) => ({
      ...prev,
      // showModal1: true,
      isEditMode: false,
      leaveType: undefined,
      leaveDuration: "",
      status: "",
      reason: "",
      singleDate: "",
      startDate: "",
      endDate: "",
      halfShortDate: "",
      halfDayType: "",
      disableAllFields: false,
      selectedEmployeeId: id,
      validationErrors,
      users: employeesForm,
    }));
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNoOfLeave(e.target.value);
  };

  const handleNotesInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = event.target;
    setNotes(value);
  };

  const handleRadioInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = event.target;
    setSelectedType(value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (["e", "E", "+", "-"].includes(e.key)) {
      e.preventDefault();
    }
  };

  const openAddLeaveBalanceModal = () => {
    if (modalInstanceRef.current) {
      modalInstanceRef.current.show();
      setIsModalOpenLeaveBalance(true);
    }
  };

  const handleSubmitLeaveBalance = async () => {
    const errors: ValidationErrors = {};

    // Validation logic
    if (!noOfLeave) {
      errors.noOfLeave = "Number of leaves is required.";
    }
    if (!selectedType) {
      errors.selectedType = "Leave type is required.";
    }
    if (!notes) {
      errors.notes = "Notes are required.";
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      setTimeout(() => {
        setValidationErrors({});
      }, 1000);
      return;
    }

    const loggedInUser = JSON.parse(localStorage.getItem("user") || "{}");
    const userIdForLeaveBalance = selectedUserIdLeaveBalance || loggedInUser.id;

    try {
      setIsSaving(true);

      const response: any = await api("/save-leave-balance", {
        method: "POST",
        body: {
          noofleaves: noOfLeave,
          type: selectedType,
          notes,
          userIdForLeaveBalance,
        },
      });

      if (response.message === "Leave balance saved successfully.") {
        toast.success(response.message);
        setTotalItems((prevCount) => {
            const newCount = prevCount + 1;
            setCurrentPageLeaveBalance(1);
            updateFilterUrl({
              selectedUserIdLeaveBalance,
              currentPageLeaveBalance: 1,
            });
            fetchLeaveBalance(); // Fetch updated leave balance
            return newCount;
        });
        closeModalLeaveBalance(); // Close the modal after success
      } else {
        const errorMsg =
          response.message || "Failed to save leave balance. Please try again.";
        toast.error(errorMsg); // Display error message
      }
    } catch (err) {
      console.error("Error saving leave balance:", err);
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    const isResetVisible =
      (selectedUserId && String(selectedUserId) !== "null") ||
      (selectedStatus && String(selectedStatus) !== "0") 
    
    const isResetVisibleLeaveBalance =
      (selectedUserIdLeaveBalance && selectedUserIdLeaveBalance !== initialId);

    const showUserSelect =
      userRole === 1 || (userRole === 2 && isReportingHead);
    console.log("isReportingHead:", isReportingHead);

    const FiltersDesktop = () => (
      <div className="px-2 px-md-2">
        <div className="attendance-filters d-flex align-items-center flex-wrap">
          <div
            className="d-flex align-items-center border bg-white rounded p-1 icon-list toggle-att-mobile"
            style={{ left: sidebarWidth, position: "absolute" }}
          >
            <Link
              to="/leave/leave-request"
              className={`btn btn-icon btn-sm ${
                tab === "leave-request"
                  ? "me-1 active bg-primary text-white"
                  : ""
              }`}
            >
              <i className="ti ti-list-details" />
            </Link>
              <Link
                to="/leave-calendar"
                className={`btn btn-icon btn-sm ${tab === 'leave-calendar' ? 'active' : ''}`}
                onClick={() => setTab('leave-calendar')}
              >
                <i className="ti ti-calendar-event" />
              </Link>
            <Link
              to="/leave/leave-balance"
              className={`btn btn-icon btn-sm ${
                tab === "leave-balance"
                  ? "me-1 active bg-primary text-white"
                  : ""
              }`}
            >
              <i className="ti ti-beach" />
            </Link>
          </div>

          <div className="d-flex align-items-center gap-2">
            {((tab === "leave-request" && isResetVisible) ||
              (tab === "leave-balance" && isResetVisibleLeaveBalance)) &&  (
              <button
                className="btn add_btn_size btn-outline-primary"
                onClick={handleReset}
                title="Reset"
              >
                <i className="ti ti-refresh" />
              </button>
            )}

            {tab === "leave-request" && (
              <>
                {showUserSelect && (
                  <CommonSelect
                    className="select"
                    options={employeesFilter.map((emp) => ({
                      value: emp.id.toString(),
                      label: emp.name,
                    }))}
                    value={employeesFilter
                      .map((emp) => ({
                        value: emp.id.toString(),
                        label: emp.name,
                      }))
                      .find((opt) => opt.value === selectedUserId?.toString())}
                    onChange={(selectedOption: Option | null) => {
                      const selectedId = selectedOption?.value || "0";
                      console.log("Selected User ID:", selectedId);
                      handleUserChange(parseInt(selectedId));
                    }}
                  />
                )}

                <div className="status-dropdown-wrapper">
                  <CommonSelect
                    className="select"
                    options={statusFilter}
                    value={statusFilter.find(
                      (option) => option.value === selectedStatus
                    )}
                    onChange={(selectedOption: Option | null) => {
                      const selected = selectedOption?.value || "0";
                      handleStatusChange(selected);
                    }}
                  />
                </div>

                <button
                  className="btn btn-outline-primary add_btn_size"
                  title="Add Leave Request"
                  onClick={() => openAddLeaveRequestModal()}
                >
                  <i className="ti ti-circle-plus" />
                </button>
              </>
            )}

            {tab === "leave-balance" && userRole === 1 && (
              <>
                <CommonSelect
                  className="select"
                  options={employeesFilterLeaveBalance.map((emp) => ({
                    value: emp.id.toString(),
                    label: emp.name,
                  }))}
                  value={employeesFilterLeaveBalance
                    .map((emp) => ({
                      value: emp.id.toString(),
                      label: emp.name,
                    }))
                    .find(
                      (opt) =>
                        opt.value === selectedUserIdLeaveBalance?.toString()
                    )}
                  onChange={(selectedOption: Option | null) => {
                    const selectedId = selectedOption?.value || "0";
                    handleUserChangeLeaveBalance(parseInt(selectedId));
                  }}
                />

                <button
                  className="btn btn-outline-primary add_btn_size"
                  title="Add Leave Balance"
                  onClick={() => openAddLeaveBalanceModal()}
                >
                  <i className="ti ti-circle-plus" />
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    );

    const FiltersMobile = () => {
      const [showModal, setShowModal] = useState(false);
      const modalRef = useRef<HTMLDivElement | null>(null);

      // Close modal on outside click
      useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
          if (
            modalRef.current &&
            !modalRef.current.contains(event.target as Node)
          ) {
            setShowModal(false);
          }
        };

        if (showModal) {
          document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [showModal]);

      return (
        <div className="px-2 px-md-2">
          <div className="attendance-filters-mobile d-flex align-items-center justify-content-between gap-2">
            {/* View toggle */}
            <div className="d-flex align-items-center border bg-white rounded p-1 icon-list toggle-att-mobile">
              <Link
                to="/leave/leave-request"
                className={`btn btn-icon btn-sm ${
                  tab === "leave-request"
                    ? "me-1 active bg-primary text-white"
                    : ""
                }`}
              >
                <i className="ti ti-list-details" />
              </Link>
              <Link to="/leave-calendar"
                className={`btn btn-icon btn-sm ${tab === 'leave-calendar' ? 'active' : ''}`}
                onClick={() => setTab('leave-calendar')} >
              </Link>
              <Link
                to="/leave/leave-balance"
                className={`btn btn-icon btn-sm ${
                  tab === "leave-balance"
                    ? "me-1 active bg-primary text-white"
                    : ""
                }`}
              >
                <i className="ti ti-beach" />
              </Link>
            </div>

            {/* Reset + Datepicker */}
            <div className="d-flex align-items-center gap-2">
              {((tab === "leave-request" && isResetVisible) ||
              (tab === "leave-balance" && isResetVisibleLeaveBalance)) &&  (
              <button
                className="btn add_btn_size btn-outline-primary"
                onClick={handleReset}
                title="Reset"
              >
                <i className="ti ti-refresh" />
              </button>
            )}
            </div>

            {!(tab === "leave-balance" && userRole === 2) && (
              <>
                {/* Filter Modal Trigger */}
                <button
                  className="btn btn-outline-primary add_btn_size"
                  onClick={() => setShowModal(true)}
                >
                  <i className="ti ti-filter" />
                </button>

                <button
                  className="btn btn-outline-primary add_btn_size"
                  title={
                    tab === "leave-request"
                      ? "Add Leave Request"
                      : "Add Leave Balance"
                  }
                  onClick={() => {
                    if (tab === "leave-request") {
                      openAddLeaveRequestModal();
                    } else if (tab === "leave-balance") {
                      openAddLeaveBalanceModal();
                    }
                  }}
                >
                  <i className="ti ti-circle-plus" />
                </button>
              </>
            )}
          </div>

          {/* Modal */}
          {showModal && (
            <div
              className="modal-backdrop"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0,0,0,0.3)",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                paddingTop: "103px",
                zIndex: 1050,
              }}
            >
              <div
                ref={modalRef}
                className="bg-white p-3 rounded shadow"
                style={{ width: "90%", maxWidth: "400px" }}
              >
                {tab === "leave-request" && (
                  <>
                    {showUserSelect && (
                      <CommonSelect
                        className="select"
                        options={employeesFilter.map((emp) => ({
                          value: emp.id.toString(),
                          label: emp.name,
                        }))}
                        value={employeesFilter
                          .map((emp) => ({
                            value: emp.id.toString(),
                            label: emp.name,
                          }))
                          .find(
                            (opt) => opt.value === selectedUserId?.toString()
                          )}
                        onChange={(selectedOption: Option | null) => {
                          const selectedId = selectedOption?.value || "0";
                          console.log("Selected User ID:", selectedId);
                          handleUserChange(parseInt(selectedId)); // still convert to number if needed
                        }}
                        forceFullWidth={isMobile}
                      />
                    )}

                    <div className="status-dropdown-wrapper">
                      <CommonSelect
                        className="select mt-2"
                        options={statusFilter}
                        value={statusFilter.find(
                          (option) => option.value === selectedStatus
                        )}
                        onChange={(selectedOption: Option | null) => {
                          const selected = selectedOption?.value || "0";
                          handleStatusChange(selected);
                        }}
                        forceFullWidth={isMobile}
                      />
                    </div>
                  </>
                )}

                {tab === "leave-balance" && userRole === 1 && (
                  <>
                    <CommonSelect
                      className="select"
                      options={employeesFilterLeaveBalance.map((emp) => ({
                        value: emp.id.toString(),
                        label: emp.name,
                      }))}
                      value={employeesFilterLeaveBalance
                        .map((emp) => ({
                          value: emp.id.toString(),
                          label: emp.name,
                        }))
                        .find(
                          (opt) =>
                            opt.value === selectedUserIdLeaveBalance?.toString()
                        )}
                      onChange={(selectedOption: Option | null) => {
                        const selectedId = selectedOption?.value || "0";
                        handleUserChangeLeaveBalance(parseInt(selectedId));
                      }}
                      forceFullWidth={isMobile}
                    />
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      );
    };

    setFilters(isMobile ? <FiltersMobile /> : <FiltersDesktop />);

    return () => setFilters(null);
  }, [
    isMobile,
    setFilters,
    isReportingHead,
    selectedUserId,
    selectedStatus,
    employeesFilter,
    statusFilter,
    employeesFilterLeaveBalance,
    tab,
    selectedUserIdLeaveBalance,
    userRole,
  ]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);

    updateFilterUrl({
      selectedUserId,
      selectedStatus,
      currentPage: page,
    });
  };

  const handlePageChangeLeaveBalance = (page: number) => {
    setCurrentPageLeaveBalance(page);

    updateFilterUrl({
      selectedUserIdLeaveBalance,
      currentPageLeaveBalance: page,
    });
  };

  const stats = [
    { title: "Total Leaves", value: leaveBalance },
    { title: "Total Balance", value: totalDuration },
    { title: "Lop", value: lopCount },
  ];

  const colSize = `col-lg-3 col-md-6`;

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {userRole === 2 && (
            <div className="row">
              {stats.map((item, index) => (
                <div key={index} className={colSize}>
                  <div className="card flex-fill att-card">
                    <div className="card-body d-flex align-items-center justify-content-between box-padding boxes-att-mobile">
                      <div className="d-flex align-items-center overflow-hidden">
                        <div>
                          <p
                            className={`fs-16 mb-1 text-truncate att-boxes-title`}
                          >
                            {item.title}
                          </p>
                          <h3 className="mb-0 att-boxes-value">{item.value}</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Table Section */}
          <div className="card card-margin-bottom">
            <div className="card-body p-0" style={{ height: tableHeight, display: "flex", flexDirection: "column" }}>
            {tab === "leave-request" ? (
              <Table
				        style={{ flex: 1 }}
                dataSource={leaveRequests}
                columns={columns}
                totalItems={totalItems}
                pageSize={pageSize}
                loading={loading}
                rowKey={(record) => record.id}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            ) : tab === "leave-balance" ? (
              <Table
                  style={{ flex: 1 }}
                dataSource={leaveBalanceList}
                columns={leaveBalanceColumns}
                totalItems={totalItemsLeaveBalance}
                pageSize={pageSize}
                loading={loading}
                rowKey={(record) => record.id}
                currentPage={currentPageLeaveBalance}
                onPageChange={handlePageChangeLeaveBalance}
              />
            ) : null}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div id="footer">
          <Footer />
        </div>
      </div>

      {/* Add Leave Balance Modal */}
      <div
        className="modal fade"
        id="leaveBalanceModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby="leaveBalanceModalLabel"
        aria-hidden="true"
        ref={modalRefRequestLeaveBalance}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="leaveBalanceModalLabel">
                Add Leave Balance
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">
                  No Of Leaves <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  name="noOfLeave"
                  className="form-control"
                  value={noOfLeave}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                />
                {validationErrors?.noOfLeave && (
                  <div style={{ color: "red" }}>
                    {validationErrors.noOfLeave}
                  </div>
                )}
              </div>

              {/* Leave Type */}
              <div className="mb-3">
                <label className="form-label">
                  Type <span className="text-danger">*</span>
                </label>
                <div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="credit"
                      name="type"
                      value="1"
                      checked={selectedType === "1"}
                      onChange={handleRadioInputChange}
                    />
                    <label className="form-check-label" htmlFor="credit">
                      Credit
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      id="debit"
                      name="type"
                      value="2"
                      checked={selectedType === "2"}
                      onChange={handleRadioInputChange}
                    />
                    <label className="form-check-label" htmlFor="debit">
                      Debit
                    </label>
                  </div>
                </div>
                {validationErrors?.selectedType && (
                  <div style={{ color: "red" }}>
                    {validationErrors.selectedType}
                  </div>
                )}
              </div>
              <div className="mb-3">
                <label className="form-label">
                  Notes <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={notes}
                  onChange={handleNotesInputChange}
                  maxLength={200}
                />
                {validationErrors?.notes && (
                  <div style={{ color: "red" }}>{validationErrors.notes}</div>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-cancel"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmitLeaveBalance}
                disabled={isSaving}
              >
                {isSaving ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </div>
      </div>

      <LeaveModal
        leaveDetails={leaveDetails}
        isOpen={isModalOpen}
        onClose={closeModal}
        onError={handleLeaveError}
        fetchLeaveRequests={fetchLeaveRequests}
        userRole={userRole ?? 0}
        onSuccess={handleLeaveSaved}
      >
        <></>
      </LeaveModal>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default Leave;